import { AnalyticsUser } from "./use-analytics-user-persistence";
import { User } from "./user";

export function extractAnalyticsUser(user: User): AnalyticsUser {
  return {
    converted: user.converted,
    primarySport: user.primarySport,
    role: user.role,
    boardVenues: user.boardVenues,
    boardPurposes: user.boardPurposes,
    boardFrequency: user.boardFrequency,
  };
}
